const eNegotiationErrorId = {
  RelationshipCreditInsufficient: "RELATIONSHIP_CREDIT_INSUFFICIENT",
};

const eNegotiationJourney = {
  Accept: "ACCEPT",
  Counter: "COUNTER",
};

export { eNegotiationErrorId, eNegotiationJourney };
